import { TrainingType } from '../../../../components/UI/templates/TripDetailsTemplate/damageTraining/damagetrainingCta';
import {
  RateCardRequestDTO,
  RateCardsResponseDTO,
} from '../../../../components/UI/templates/TripDetailsTemplate/RateCardInputModal/contracts';
import MarketPlaceActionTypes from './types';

export const fetchOperatorTripsStart = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_OPERATOR_TRIPS_START,
  payload: payload,
});

export const clearOperatorTrips = () => ({
  type: MarketPlaceActionTypes.CLEAR_OPERATOR_TRIPS,
  payload: null,
});

export const clearLoadsFlags = () => ({
  type: MarketPlaceActionTypes.CLEAR_LOADS_FLAGS,
  payload: null,
});

export const fetchOperatorTripsSuccess = (data: any) => ({
  type: MarketPlaceActionTypes.FETCH_OPERATOR_TRIPS_SUCCESS,
  payload: data,
});

export const fetchOperatorTripsFailure = (errorMessage: any) => ({
  type: MarketPlaceActionTypes.FETCH_OPERATOR_TRIPS_FAILURE,
  payload: errorMessage,
});

export const fetchStatesStart = () => ({
  type: MarketPlaceActionTypes.FETCH_STATES_START,
});

export const fetchStatesSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_STATES_SUCCESS,
  payload: payload,
});

export const fetchStatesFailure = () => ({
  type: MarketPlaceActionTypes.FETCH_STATES_FAILURE,
});

export const fetchLoadsStart = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_LOADS_START,
  payload: payload,
});

export const fetchLoadsSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_LOADS_SUCCESS,
  payload: payload,
});

export const fetchLoadsFailure = () => ({
  type: MarketPlaceActionTypes.FETCH_LOADS_FAILURE,
});

export const saveOpQuoteAmount = (payload: any) => ({
  type: MarketPlaceActionTypes.SAVE_OP_QUOTE_AMOUNT,
  payload,
});

export const resetOpQuoteAmount = () => ({
  type: MarketPlaceActionTypes.RESET_OP_QUOTE_AMOUNT,
});

export const setSelectedState = (payload: any) => ({
  type: MarketPlaceActionTypes.SET_SELECTED_STATE,
  payload,
});

export const setFirstAcceptance = (payload: any) => ({
  type: MarketPlaceActionTypes.SET_FIRST_ACCEPTANCE,
  payload,
});

export const setShowBackWarning = (payload: any) => ({
  type: MarketPlaceActionTypes.SET_SHOW_BACK_WARNING,
  payload,
});

export const setLoadSeen = (payload: any) => ({
  type: MarketPlaceActionTypes.SET_LOAD_SEEN,
  payload,
});

export const saveOpResponseStart = (payload: any) => ({
  type: MarketPlaceActionTypes.SAVE_OP_RESPONSE_START,
  payload,
});

export const saveOpResponseSuccess = (data: any) => ({
  type: MarketPlaceActionTypes.SAVE_OP_RESPONSE_SUCCESS,
  payload: data,
});

export const saveOpResponseRejected = (data: any) => ({
  type: MarketPlaceActionTypes.SAVE_OP_RESPONSE_REJECTED,
  payload: data,
});

export const saveOpResponseFailure = (errorMessage: any) => ({
  type: MarketPlaceActionTypes.SAVE_OP_RESPONSE_FAILURE,
  payload: errorMessage,
});

export const callPocStart = (payload: any) => ({
  type: MarketPlaceActionTypes.CALL_POC_START,
  payload,
});

export const callPocSuccess = (data: any) => ({
  type: MarketPlaceActionTypes.CALL_POC_SUCCESS,
  payload: data,
});

export const callPocFailure = (errorMessage: any) => ({
  type: MarketPlaceActionTypes.CALL_POC_FAILURE,
  payload: errorMessage,
});

export const fetchTripExpenseStart = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_TRIP_EXPENSE_START,
  payload: payload,
});
export const fetchTripExpenseStartV2 = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_TRIP_EXPENSE_START_V2,
  payload: payload,
});

export const fetchTripExpenseSuccess = (data: any) => ({
  type: MarketPlaceActionTypes.FETCH_TRIP_EXPENSE_SUCCESS,
  payload: data,
});

export const fetchTripExpenseFailure = (errorMessage: any) => ({
  type: MarketPlaceActionTypes.FETCH_TRIP_EXPENSE_FAILURE,
  payload: errorMessage,
});

export const fetchTripTrackingStart = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_TRIP_TRACKING_DETAILS_START,
  payload: payload,
});
export const fetchTripTrackingStartV2 = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_TRIP_TRACKING_DETAILS_START_V2,
  payload: payload,
});
export const fetchTripTrackingSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_TRIP_TRACKING_DETAILS_SUCCESS,
  payload: payload,
});
export const fetchTripTrackingFailure = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_TRIP_TRACKING_DETAILS_FAILURE,
  payload: payload,
});
export const tripTrackingDataReset = () => ({
  type: MarketPlaceActionTypes.TRIP_TRACKING_DATA_RESET,
});

export const startTripPodOtpPoll = (tripId: string) => ({
  type: MarketPlaceActionTypes.START_TRIP_POD_OTP_POLL,
  payload: tripId,
});

export const stopTripPodOtpPoll = () => ({
  type: MarketPlaceActionTypes.STOP_TRIP_POD_OTP_POLL,
});

export const mergeTripPodOtpWidgets = (payload: {
  podOtpAndBalanceInfoTimer?: unknown;
  podAndOtpSubmitWidget?: unknown;
}) => ({
  type: MarketPlaceActionTypes.MERGE_TRIP_POD_OTP_WIDGETS,
  payload,
});

export const fetchPaymentHistoryStart = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_PAYMENT_HISTORY_START,
  payload: payload,
});
export const fetchPaymentHistoryStartV2 = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_PAYMENT_HISTORY_START_V2,
  payload: payload,
});

export const fetchPaymentHistorySuccess = (data: any) => ({
  type: MarketPlaceActionTypes.FETCH_PAYMENT_HISTORY_SUCCESS,
  payload: data,
});

export const fetchPaymentHistoryFailure = (errorMessage: any) => ({
  type: MarketPlaceActionTypes.FETCH_PAYMENT_HISTORY_FAILURE,
  payload: errorMessage,
});

export const fetchTripSummaryStart = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_TRIP_SUMMARY_START,
  payload: payload,
});
export const fetchTripSummaryStartV2 = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_TRIP_SUMMARY_START_V2,
  payload: payload,
});

export const fetchTripSummarySuccess = (data: any) => ({
  type: MarketPlaceActionTypes.FETCH_TRIP_SUMMARY_SUCCESS,
  payload: data,
});

export const fetchTripSummaryFailure = (errorMessage: any) => ({
  type: MarketPlaceActionTypes.FETCH_TRIP_SUMMARY_FAILURE,
  payload: errorMessage,
});

export const fetchLoadDetailsStart = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_LOAD_DETAILS_START,
  payload: payload,
});

export const fetchLoadDetailsSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_LOAD_DETAILS_SUCCESS,
  payload: payload,
});

export const fetchLoadDetailsFailure = () => ({
  type: MarketPlaceActionTypes.FETCH_LOAD_DETAILS_FAILURE,
});

export const fetchLoadQuoteQualityStart = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_LOAD_QUOTE_QUALITY_START,
  payload: payload,
});

export const fetchLoadQuoteQualitySuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_LOAD_QUOTE_QUALITY_SUCCESS,
  payload: payload,
});
export const fetchLoadQuoteQualityFailure = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_LOAD_QUOTE_QUALITY_FAILURE,
  payload: payload,
});

export const postLoadQuoteStart = (params: any, payload: any) => ({
  type: MarketPlaceActionTypes.POST_LOAD_QUOTE_START,
  params,
  payload,
});

export const postLoadQuoteSuccess = (data: any) => ({
  type: MarketPlaceActionTypes.POST_LOAD_QUOTE_SUCCESS,
  payload: data,
});

export const postLoadQuoteReset = () => ({
  type: MarketPlaceActionTypes.POST_LOAD_QUOTE_RESET,
});

export const postLoadQuoteFailure = (errorMessage: any) => ({
  type: MarketPlaceActionTypes.POST_LOAD_QUOTE_FAILURE,
  payload: errorMessage,
});

export const getSearchOptionsStart = (payload: any) => ({
  type: MarketPlaceActionTypes.GET_SEARCH_OPTIONS_START,
  payload: payload,
});

export const getSearchOptionsSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.GET_SEARCH_OPTIONS_SUCCESS,
  payload: payload,
});
export const getSearchOptionsFailure = (payload: any) => ({
  type: MarketPlaceActionTypes.GET_SEARCH_OPTIONS_FAILURE,
  payload: payload,
});

export const getselectPlaceStart = (payload: any) => ({
  type: MarketPlaceActionTypes.GET_SELECT_PLACE_START,
  payload: payload,
});
export const getselectPlaceSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.GET_SELECT_PLACE_SUCCESS,
  payload: payload,
});
export const getselectPlaceFailure = (payload: any) => ({
  type: MarketPlaceActionTypes.GET_SELECT_PLACE_FAILURE,
  payload: payload,
});

export const getEmptySearchStart = (payload: any) => ({
  type: MarketPlaceActionTypes.GET_EMPTY_SEARCH_START,
  payload: payload,
});
export const getEmptySearchSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.GET_EMPTY_SEARCH_SUCCESS,
  payload: payload,
});
export const getEmptySearchFailure = (payload: any) => ({
  type: MarketPlaceActionTypes.GET_EMPTY_SEARCH_FAILURE,
  payload: payload,
});

export const getPlaceholderBannerDetailsStart = (payload: any) => ({
  type: MarketPlaceActionTypes.GET_PLACEHOLDER_BANNER_DETAILS_START,
  payload: payload,
});

export const getPlaceholderBannerDetailSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.GET_PLACEHOLDER_BANNER_DETAILS_SUCCESS,
  payload: payload,
});

export const getPlaceholderBannerDetailsFailure = (payload: any) => ({
  type: MarketPlaceActionTypes.GET_PLACEHOLDER_BANNER_DETAILS_FAILURE,
  payload: payload,
});

export const postUploadDocPodStart = (payload: any, typeImg: any, imgSide: any) => ({
  type: MarketPlaceActionTypes.POST_UPLOAD_DOC_POD_START,
  // params,
  payload,
  typeImg,
  imgSide,
});

export const postUploadDocPodSuccess = (params: any, payload: any) => ({
  type: MarketPlaceActionTypes.POST_UPLOAD_DOC_POD_SUCCESS,
  params,
  payload,
});

export const podSuccesOnaws = (payload: any) => ({
  type: MarketPlaceActionTypes.POST_AWS_SUCCESS,
  payload,
});

export const podResourceKey = (payload: any, typeOf: any) => ({
  type: MarketPlaceActionTypes.GET_RESOURCE_KEY_POD,
  payload,
  typeOf,
});

export const getUploadedImagesStart = (payload: any, typeImg: any) => ({
  type: MarketPlaceActionTypes.GET_UPLOADED_IMAGES_START,
  payload,
  typeImg,
});
export const getUploadedImagesSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.GET_UPLOADED_IMAGES_SUCCESS,
  payload,
});
export const getUploadedImagesFailure = (payload: any) => ({
  type: MarketPlaceActionTypes.GET_UPLOADED_IMAGES_FAILURE,
  payload,
});

export const getUploadedImagesSingleStart = () => ({
  type: MarketPlaceActionTypes.GET_UPLOADED_IMAGES_SINGLE_START,
});
export const getUploadedImagesSingleSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.GET_UPLOADED_IMAGES_SINGLE_SUCCESS,
  payload,
});
export const getUploadedImagesSingleFailure = (payload: any) => ({
  type: MarketPlaceActionTypes.GET_UPLOADED_IMAGES_SINGLE_FAILURE,
  payload,
});

export const fetchPodDetailsActionStart = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_POD_DETAILS_START,
  payload: payload,
});

export const fetchPodDetailsActionSuccess = (data: any) => ({
  type: MarketPlaceActionTypes.FETCH_POD_DETAILS_SUCCESS,
  payload: data,
});

export const fetchPodDetailsActionFailure = (errorMessage: any) => ({
  type: MarketPlaceActionTypes.FETCH_POD_DETAILS_FAILURE,
  payload: errorMessage,
});

export const PodPostUploadDocSubmitStart = (payload: any) => ({
  type: MarketPlaceActionTypes.POST_POD_DATA_UPDATE_START,
  // params,
  payload,
});

export const PodPostUploadDocSubmitSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.POST_POD_DATA_UPDATE_SUCCESS,
  // params,
  payload,
});

export const unLoadingSearchResultsStart = (payload: any) => ({
  type: MarketPlaceActionTypes.UNLOADING_SEARCH_RESULTS_START,
  payload: payload,
});

export const unLoadingSearchResultsSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.UNLOADING_SEARCH_RESULTS_SUCCESS,
  payload: payload,
});

export const unLoadingSearchResultsFailure = (payload: any) => ({
  type: MarketPlaceActionTypes.UNLOADING_SEARCH_RESULTS_FAILURE,
  payload: payload,
});

export const resetList = () => ({
  type: MarketPlaceActionTypes.RESET_LIST,
});

export const vehicleAvailModalShowStart = () => ({
  type: MarketPlaceActionTypes.VEHCILE_AVAIL_MODAL_SHOW_START,
});
export const vehicleAvailModalShowSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.VEHCILE_AVAIL_MODAL_SHOW_SUCCESS,
  payload: payload,
});
export const vehicleAvailModalShowFailure = (payload: any) => ({
  type: MarketPlaceActionTypes.VEHCILE_AVAIL_MODAL_SHOW_FAILURE,
  payload: payload,
});

// export const clearOperatorGivenQuote = () => ({
//   type:MarketPlaceActionTypes.
// })

export const initiateMembershipPaymentStart = (payload: any) => ({
  type: MarketPlaceActionTypes.INITIATE_MEMBERSHIP_PAYMENT_START,
  payload: payload,
});

export const initiateMembershipPaymentSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.INITIATE_MEMBERSHIP_PAYMENT_SUCCESS,
  payload: payload,
});

export const initiateMembershipPaymentReset = (payload: any) => ({
  type: MarketPlaceActionTypes.INITIATE_MEMBERSHIP_PAYMENT_RESET,
  payload: payload,
});

export const initiateMembershipPaymentFailure = (payload: any) => ({
  type: MarketPlaceActionTypes.INITIATE_MEMBERSHIP_PAYMENT_FAILURE,
  payload: payload,
});

export const membershipPaymentProcessStart = (payload: any) => ({
  type: MarketPlaceActionTypes.MEMBERSHIP_PAYMENT_PROCESS_START,
  payload: payload,
});

export const membershipPaymentProcessSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.MEMBERSHIP_PAYMENT_PROCESS_SUCCESS,
  payload: payload,
});

export const membershipPaymentProcessFailure = (payload: any) => ({
  type: MarketPlaceActionTypes.MEMBERSHIP_PAYMENT_PROCESS_FAILURE,
  payload: payload,
});

export const surveyGetQuestionStart = () => ({
  type: MarketPlaceActionTypes.SURVEY_GET_QUESTION_START,
});
export const surveyGetQuestionSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.SURVEY_GET_QUESTION_SUCCESS,
  payload: payload,
});
export const surveyGetQuestionFailure = (payload: any) => ({
  type: MarketPlaceActionTypes.SURVEY_GET_QUESTION_FAILURE,
  payload: payload,
});

export const surveyFormSubmitActionStart = (payload: any) => ({
  type: MarketPlaceActionTypes.POST_SURVEY_FORM_START,
  // params,
  payload,
});

export const surveyFormSubmitActionSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.POST_SURVEY_FORM_SUCCESS,
  // params,
  payload,
});

export const surveyFormSubmitActionFailure = (payload: any) => ({
  type: MarketPlaceActionTypes.POST_SURVEY_FORM_FAILURE,
  // params,
  payload,
});
export const podAwsImgUrl = (payload: any) => ({
  type: MarketPlaceActionTypes.GET_POD_IMG_AWS_URL,
  payload,
});

export const otpSubmitActionStart = (payload: any) => ({
  type: MarketPlaceActionTypes.POST_OTP_START,
  payload,
});

export const otpSubmitActionSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.POST_OTP_SUCCESS,
  payload,
});

export const otpSubmitActionFailure = (payload: any) => ({
  type: MarketPlaceActionTypes.POST_OTP_SUCCESS,
  payload,
});

// for detail page otp flow
export const otpStageSubmitActionStart = (payload: any) => ({
  type: MarketPlaceActionTypes.POST_OTP_STAGE_START,
  payload,
});

export const otpStageSubmitActionSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.POST_OTP_STAGE_SUCCESS,
  payload,
});

export const otpStageSubmitActionFailure = (payload: any) => ({
  type: MarketPlaceActionTypes.POST_OTP_STAGE_SUCCESS,
  payload,
});

// TRIP DETAIL - STATE CHANGE CONFIRM WARNING
export const tripDetailStateChangeConfirmWarningStart = (payload: any) => ({
  type: MarketPlaceActionTypes.TRIP_DETAIL_STATE_CHANGE_CONFIRM_WARNING_START,
  payload,
});

export const tripDetailStateChangeConfirmWarningStop = () => ({
  type: MarketPlaceActionTypes.TRIP_DETAIL_STATE_CHANGE_CONFIRM_WARNING_STOP,
});

// TRIP DETAIL - STATE CHANGE VALIDATION
export const tripDetailStateChangeValidationStart = (payload: any) => ({
  type: MarketPlaceActionTypes.TRIP_DETAIL_STATE_CHANGE_VALIDATION_START,
  payload,
});

export const tripDetailStateChangeValidationSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.TRIP_DETAIL_STATE_CHANGE_VALIDATION_SUCCESS,
  payload,
});

export const tripDetailStateChangeValidationFailure = (payload: any) => ({
  type: MarketPlaceActionTypes.TRIP_DETAIL_STATE_CHANGE_VALIDATION_FAILURE,
  payload,
});

export const fetchOperatorProfileDetailsStart = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_OPERATOR_PROFILE_START,
  payload: payload,
});
export const fetchOperatorProfileDetailsSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_OPERATOR_PROFILE_SUCCESS,
  payload: payload,
});
export const fetchOperatorProfileDetailsFailure = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_OPERATOR_PROFILE_FAILURE,
  payload: payload,
});

export const fetchAppConfig = () => ({
  type: MarketPlaceActionTypes.FETCH_APP_CONFIG,
});
export const fetchAppConfigSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_APP_CONFIG_SUCCESS,
  payload,
});
export const fetchAppConfigFailure = () => ({
  type: MarketPlaceActionTypes.FETCH_APP_CONFIG_FAILURE,
});

export const uploadImgAws = (payload: any) => ({
  type: MarketPlaceActionTypes.POST_IMG_AWS,
  payload: payload,
});
export const uploadImgAwsSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.POST_IMG_AWS_SUCCESS,
  payload: payload,
});
export const uploadImgAwsFailure = (payload: any) => ({
  type: MarketPlaceActionTypes.POST_IMG_AWS_FAILURE,
  payload: payload,
});

export const submitBulkUpload = (payload: any) => ({
  type: MarketPlaceActionTypes.SUBMIT_BULK_POD,
  payload,
});
export const submitBulkUploadSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.SUBMIT_BULK_POD_SUCCESS,
  payload,
});
export const submitBulkUploadFailure = () => ({
  type: MarketPlaceActionTypes.SUBMIT_BULK_POD_FAILURE,
});

export const removeResourceKeys = (payload: any) => ({
  type: MarketPlaceActionTypes.REMOVE_RESOURCE_KEY,
  payload,
});
export const imgUploadStatus = (payload: any) => ({
  type: MarketPlaceActionTypes.IMG_UPLOAD_STATUS_SUCCESS,
  payload,
});

export const resetPODDto = () => ({
  type: MarketPlaceActionTypes.RESET_POD_DTO,
});

export const sendResponseEventStart = (payload: any) => ({
  type: MarketPlaceActionTypes.SEND_RESPONSE_EVENT_START,
  payload,
});
export const sendResponseEventSuccess = (data: any) => ({
  type: MarketPlaceActionTypes.SEND_RESPONSE_EVENT_SUCCESS,
  payload: data,
});
export const sendResponseEventFailure = (data: any) => ({
  type: MarketPlaceActionTypes.SEND_RESPONSE_EVENT_FAILURE,
  payload: data,
});
export const resetValidatorCheck = () => ({
  type: MarketPlaceActionTypes.RESET_VALIDATOR_CHECK,
});

export const fetchOperatorDetailsStart = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_OPERATOR_DETAILS_TDS_START,
  payload: payload,
});

export const fetchOperatorDetailsSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_OPERATOR_DETAILS_TDS_SUCCESS,
  payload: payload,
});

export const fetchOperatorDetailsFailure = (errorMessage: any) => ({
  type: MarketPlaceActionTypes.FETCH_OPERATOR_DETAILS_TDS_FAILURE,
  payload: errorMessage,
});

export const initiateOperatorTdsDeclarationStart = (payload: any) => ({
  type: MarketPlaceActionTypes.INITIATE_OPERATOR_TDS_DECLARATION_TDS_START,
  payload: payload,
});

export const initiateOperatorTdsDeclarationSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.INITIATE_OPERATOR_TDS_DECLARATION_TDS_SUCCESS,
  payload: payload,
});

export const initiateOperatorTdsDeclarationFailure = (payload: any) => ({
  type: MarketPlaceActionTypes.INITIATE_OPERATOR_TDS_DECLARATION_TDS_FAILURE,
  payload: payload,
});

export const initiateOperatorTdsDeclarationReset = () => ({
  type: MarketPlaceActionTypes.INITIATE_OPERATOR_TDS_DECLARATION_TDS_RESRET,
});

export const initiateOperatorTdsDeclarationDetailReset = () => ({
  type: MarketPlaceActionTypes.INITIATE_OPERATOR_TDS_DECLARATION_TDS_DETAIL_RESET,
});
export const getAppConfigV2 = () => ({
  type: MarketPlaceActionTypes.GET_APP_CONFIG_V2,
});
export const getAppConfigV2Success = (payload: any) => ({
  type: MarketPlaceActionTypes.GET_APP_CONFIG_V2_SUCCESS,
  payload,
});
export const getAppConfigV2Failure = () => ({
  type: MarketPlaceActionTypes.GET_APP_CONFIG_V2_FAILURE,
});

export const patchAppConfigV2 = (payload: any) => ({
  type: MarketPlaceActionTypes.PATCH_APP_CONFIG_V2,
  payload,
});
export const patchAppConfigV2Success = () => ({
  type: MarketPlaceActionTypes.PATCH_APP_CONFIG_V2_SUCCESS,
});
export const patchAppConfigV2Failure = () => ({
  type: MarketPlaceActionTypes.PATCH_APP_CONFIG_V2_FAILURE,
});
export const fetchOperatorTicketStart = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_OPERATOR_TICKETS_START,
  payload,
});
export const fetchOperatorTicketSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_OPERATOR_TICKETS_SUCCESS,
  payload,
});
export const fetchOperatorTicketFailure = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_OPERATOR_TICKETS_FAILURE,
  payload,
});
export const fetchOperatorPolicyStatusStart = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_OPERATOR_POLICY_STATUS_START,
  payload,
});
export const fetchOperatorPolicyStatusSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_OPERATOR_POLICY_STATUS_SUCCESS,
  payload,
});
export const fetchOperatorPolicyStatusFailure = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_OPERATOR_POLICY_STATUS_FAILURE,
  payload,
});
export const fetchOperatorPolicyStatusReset = () => ({
  type: MarketPlaceActionTypes.FETCH_OPERATOR_POLICY_STATUS_RESET,
});
export const postOperatorPolicyAcceptStart = (payload: any) => ({
  type: MarketPlaceActionTypes.POST_OPERATOR_POLICY_ACCEPT_START,
  payload,
});
export const postOperatorPolicyAcceptSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.POST_OPERATOR_POLICY_ACCEPT_SUCCESS,
  payload,
});
export const postOperatorPolicyAcceptFailure = (payload: any) => ({
  type: MarketPlaceActionTypes.POST_OPERATOR_POLICY_ACCEPT_FAILURE,
  payload,
});

export const getTripRemarks = (payload: any) => ({
  type: MarketPlaceActionTypes.GET_TRIP_REMARKS,
  payload,
});
export const getTripRemarksSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.GET_TRIP_REMARKS_SUCCESS,
  payload,
});
export const getTripRemarksFailure = () => ({
  type: MarketPlaceActionTypes.GET_TRIP_REMARKS_FAILURE,
});

export const getTripSlots = (payload: any) => ({
  type: MarketPlaceActionTypes.GET_TIME_SLOTS,
  payload,
});
export const getTripSlotsSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.GET_TIME_SLOTS_SUCCESS,
  payload,
});
export const getTripSlotsFailure = () => ({
  type: MarketPlaceActionTypes.GET_TIME_SLOTS_FAILURE,
});
export const updateSlotsRemarks = (payload: any) => ({
  type: MarketPlaceActionTypes.PATCH_REMARKS,
  payload,
});
export const updateSlotsRemarksSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.PATCH_REMARKS_SUCCESS,
  payload,
});
export const updateSlotsRemarksFailure = () => ({
  type: MarketPlaceActionTypes.PATCH_REMARKS_FAILURE,
});

export const fetchSubscription = () => ({
  type: MarketPlaceActionTypes.FETCH_SUBSCRIPTION_CONFIG,
});
export const fetchSubscriptionSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_SUBSCRIPTION_SUCCESS,
  payload,
});
export const fetchSubscriptionFailure = () => ({
  type: MarketPlaceActionTypes.FETCH_APP_CONFIG_FAILURE,
});

export const updateCancelReason = (payload: any) => ({
  type: MarketPlaceActionTypes.POST_CANCEL_REASON,
  payload,
});
export const updateCancelReasonSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.POST_CANCEL_REASON_SUCCESS,
  payload,
});
export const updateCancelReasonFailure = () => ({
  type: MarketPlaceActionTypes.POST_CANCEL_REASON_FAILURE,
});

export const fetchTripFiltersData = () => ({
  type: MarketPlaceActionTypes.FETCH_TRIP_FILTERS,
});
export const fetchTripFiltersDataSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_TRIP_FILTERS_SUCCESS,
  payload,
});
export const fetchTripFiltersDataFailure = () => ({
  type: MarketPlaceActionTypes.FETCH_TRIP_FILTERS_FAILURE,
});
export const applyTripFilter = (payload: any) => ({
  type: MarketPlaceActionTypes.APPLY_FILTER,
  payload,
});
export const fetchSettingsRequest = () => ({
  type: MarketPlaceActionTypes.FETCH_SETTINGS_REQUEST,
});
export const fetchSettingsSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_SETTINGS_SUCCESS,
  payload,
});
export const fetchSettingsFailure = () => ({
  type: MarketPlaceActionTypes.FETCH_SETTINGS_FAILURE,
});
export const saveSettingsRequest = (payload: any) => ({
  type: MarketPlaceActionTypes.SAVE_SETTINGS_REQUEST,
  payload,
});
export const saveSettingsSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.SAVE_SETTINGS_SUCCESS,
  payload,
});
export const saveSettingsFailure = () => ({
  type: MarketPlaceActionTypes.SAVE_SETTINGS_FAILURE,
});
export const patchSubmitPanAdhaarLink = () => ({
  type: MarketPlaceActionTypes.PATCH_PAN_ADHAAR,
});

export const demandEditConfirmationRequest = (payload: any) => ({
  type: MarketPlaceActionTypes.DEMAND_EDIT_CONFIRMATION_REQUEST,
  payload,
});
export const demandEditConfirmationSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.DEMAND_EDIT_CONFIRMATION_SUCCESS,
  payload,
});
export const demandEditConfirmationsFailure = () => ({
  type: MarketPlaceActionTypes.DEMAND_EDIT_CONFIRMATION_FAILURE,
});

export const getRatingTrainingRequest = (payload: any) => ({
  type: MarketPlaceActionTypes.GET_RAITING_TRAINING_REQUEST,
  payload,
});
export const getRatingTrainingSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.GET_RAITING_TRAINING_SUCCESS,
  payload,
});
export const getRatingTrainingFailure = () => ({
  type: MarketPlaceActionTypes.GET_RAITING_TRAINING_FAILURE,
});

export const getInvoiceRequest = (payload: any) => ({
  type: MarketPlaceActionTypes.GET_INVOICE_REQUEST,
  payload,
});
export const getInvoiceSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.GET_INVOICE_SUCCESS,
  payload,
});
export const getInvoiceFailure = () => ({
  type: MarketPlaceActionTypes.GET_INVOICE_FAILURE,
});

export const patchInvoiceRequest = (payload: any) => ({
  type: MarketPlaceActionTypes.PATCH_INVOICE_REQUEST,
  payload,
});
export const patchInvoiceSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.PATCH_INVOICE_SUCCESS,
  payload,
});
export const patchInvoiceFailure = () => ({
  type: MarketPlaceActionTypes.PATCH_INVOICE_SUCCESS,
});
export const uploadImageRequest = (payload: any) => ({
  type: MarketPlaceActionTypes.UPLOAD_IMAGE_REQUEST,
  payload,
});
export const uploadImageSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.UPLOAD_IMAGE_SUCCESS,
  payload,
});
export const uploadImageFailure = () => ({
  type: MarketPlaceActionTypes.UPLOAD_IMAGE_FAILURE,
});

export const uploadImageAwsRequest = (payload: any) => ({
  type: MarketPlaceActionTypes.UPLOAD_IMAGE_AWS_REQUEST,
  payload,
});
export const uploadImageAwsSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.UPLOAD_IMAGE_AWS_SUCCESS,
  payload,
});
export const uploadImageAwsFailure = () => ({
  type: MarketPlaceActionTypes.UPLOAD_IMAGE_AWS_FAILURE,
});
export const fetchWeLang = () => ({
  type: MarketPlaceActionTypes.FETCH_WELANG,
});
export const fetchWeLangSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_WELANG_SUCCESS,
  payload,
});
export const fetchWeLangFailure = () => ({
  type: MarketPlaceActionTypes.FETCH_WELANG_FAILURE,
});
export const fetchTrainingContent = (payload: any) => ({
  type: MarketPlaceActionTypes.GET_TRAINING_CONTENT_REQUEST,
  payload,
});
export const fetchTrainingContentSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.GET_TRAINING_CONTENT_SUCCESS,
  payload,
});

// SESSION UPDATE API actions (common for all session operations)
export const sessionUpdateRequest = (payload: {
  tripId: string;
  referenceId: number;
  actionType: 'GET_STATE' | 'GET_HELP' | 'GET_HELP_15_MIN_COMPLETE' | 'GET_HELP_FINAL';
}) => ({
  type: MarketPlaceActionTypes.SESSION_UPDATE_REQUEST,
  payload,
});

export const sessionUpdateSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.SESSION_UPDATE_SUCCESS,
  payload,
});

export const sessionUpdateFailure = () => ({
  type: MarketPlaceActionTypes.SESSION_UPDATE_FAILURE,
});
export const fetchTrainingContentFailure = () => ({
  type: MarketPlaceActionTypes.GET_TRAINING_CONTENT_FAILURE,
});

export const fetchTrainingContentV2 = (payload: { trainingType: TrainingType; tripId: string }) => ({
  type: MarketPlaceActionTypes.FETCH_TRAINING_CONTENT_V2_REQUEST,
  payload,
});

export const fetchTrainingContentV2Success = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_TRAINING_CONTENT_V2_SUCCESS,
  payload,
});

export const fetchTrainingContentV2Failure = () => ({
  type: MarketPlaceActionTypes.FETCH_TRAINING_CONTENT_V2_FAILURE,
});

export const fetchDetentionContent = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_DETENTION_CONTENT_REQUEST,
  payload,
});
export const fetchDetentionContentSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_DETENTION_CONTENT_SUCCESS,
  payload,
});
export const fetchDetentionContentFailure = () => ({
  type: MarketPlaceActionTypes.FETCH_DETENTION_CONTENT_FAILURE,
});
export const submitTrainingCompletion = (payload: any) => ({
  type: MarketPlaceActionTypes.PUT_COMPLETE_TRAINING_REQUEST,
  payload,
});
export const submitTrainingCompletionSuccess = () => ({
  type: MarketPlaceActionTypes.PUT_COMPLETE_TRAINING_SUCCESS,
});
export const submitTrainingCompletionFailure = () => ({
  type: MarketPlaceActionTypes.PUT_COMPLETE_TRAINING_FAILURE,
});
export const emptyTrainingContent = () => ({
  type: MarketPlaceActionTypes.EMPTY_TRAINING_CONTENT,
});

export const postAcknowledgement = (payload: any) => ({
  type: MarketPlaceActionTypes.POST_ACKNOWLEDGEMENT,
  payload,
});

export const postAcknowledgementSuccess = (response: any) => ({
  type: MarketPlaceActionTypes.POST_ACKNOWLEDGEMENT_SUCCESS,
  response,
});

export const postAcknowledgementFailure = () => ({
  type: MarketPlaceActionTypes.POST_ACKNOWLEDGEMENT_FAILURE,
});

export const asyncFetchRateCards = () => ({
  type: MarketPlaceActionTypes.FETCH_RATE_CARDS,
});

export const asyncFetchRateCardsSuccess = (payload: RateCardsResponseDTO) => ({
  type: MarketPlaceActionTypes.FETCH_RATE_CARDS_SUCCESS,
  payload,
});

export const asyncFetchRateCardsFailure = () => ({
  type: MarketPlaceActionTypes.FETCH_RATE_CARDS_FAILURE,
});
export const asyncPostSubmitRateCardResponse = (payload: RateCardRequestDTO) => ({
  type: MarketPlaceActionTypes.SUBMIT_USER_RATE_CARD_RESPONSE,
  payload,
});
export const asyncPostSubmitRateCardResponseSuccess = () => ({
  type: MarketPlaceActionTypes.SUBMIT_USER_RATE_CARD_RESPONSE_SUCCESS,
});
export const asyncPostSubmitRateCardResponseFailure = () => ({
  type: MarketPlaceActionTypes.SUBMIT_USER_RATE_CARD_RESPONSE_FAILURE,
});
export const resetRateCards = () => ({
  type: MarketPlaceActionTypes.RESET_RATE_CARDS,
});
export const asyncGetRemarksList = (payload: any) => ({
  type: MarketPlaceActionTypes.GET_REMARKS_LIST,
  payload,
});
export const asyncGetRemarksListSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.GET_REMARKS_LIST_SUCCESS,
  payload,
});
export const asyncGetRemarksListFailure = () => ({
  type: MarketPlaceActionTypes.GET_REMARKS_LIST_FAILURE,
});

export const updateDelayRemarks = (payload: any) => ({
  type: MarketPlaceActionTypes.UPDATE_DELAY_REMARKS,
  payload,
});
export const updateDelayRemarksSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.UPDATE_DELAY_REMARKS_SUCCESS,
  payload,
});
export const updateDelayRemarksFailure = (payload: any) => ({
  type: MarketPlaceActionTypes.UPDATE_DELAY_REMARKS_FAILURE,
  payload,
});

export const reasonSubmitStart = (payload: any) => ({
  type: MarketPlaceActionTypes.REASON_SUBMIT_START,
  payload,
});

export const reasonSubmitSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.REASON_SUBMIT_SUCCESS,
  payload,
});

export const reasonSubmitFailure = (payload: any) => ({
  type: MarketPlaceActionTypes.REASON_SUBMIT_FAILURE,
  payload,
});

export const fetchAdvanceStateViewStart = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_ADVANCE_STATE_VIEW_START,
  payload,
});

export const fetchAdvanceStateViewSuccess = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_ADVANCE_STATE_VIEW_SUCCESS,
  payload,
});

export const fetchAdvanceStateViewFailure = (payload: any) => ({
  type: MarketPlaceActionTypes.FETCH_ADVANCE_STATE_VIEW_FAILURE,
  payload,
});
